export type LegalParagraph = {
  /** Félkövér bevezető rész (opcionális). */
  label?: string
  text?: string
}

export type LegalDoc = {
  id: string
  title: string
  paragraphs: LegalParagraph[]
}

export const legalDocs: LegalDoc[] = [
  {
    id: 'adatvedelem',
    title: 'Adatvédelem',
    paragraphs: [
      { text: 'Tiszteletben tartjuk mindenki magánszféráját, aki meglátogatja ezt az oldalt, vásárol, vagy ír nekünk.' },
      {
        label: '1. Milyen adatokat gyűjtünk:',
        text: 'név, e-mail-cím, elérhetőségek és a vásárlás feldolgozásához szükséges adatok.',
      },
      {
        label: '2. Mire használjuk őket:',
        text: 'a rendelések kezelésére, a digitális termék kézbesítésére, ügyfélszolgálatra és az élményed javítására.',
      },
      {
        label: '3. Fizetés és biztonság:',
        text: 'a fizetéseket biztonságos külső platformok dolgozzák fel. Bankkártyaadatokat nem tárolunk.',
      },
      {
        label: '4. Harmadik felek:',
        text: 'az adataidat nem adjuk el. Csak akkor osztjuk meg őket, ha ez a szolgáltatás működéséhez szükséges.',
      },
    ],
  },
  {
    id: 'aszf',
    title: 'Általános szerződési feltételek',
    paragraphs: [
      {
        text: 'A vásárlással elfogadod ezeket a feltételeket. A hozzáférés személyes és át nem ruházható. Az anyagokat saját használatra és az általad vezetett egyéni vagy csoportos foglalkozásokhoz kinyomtathatod. A digitális fájlok továbbértékesítése, terjesztése és másokkal való megosztása tilos.',
      },
      { label: 'Termék:', text: '100%-ban digitális termék. Semmit nem postázunk.' },
      { label: 'Hozzáférés:', text: 'rögtön a vásárlás után megkapod, az e-mail-címedre küldött linken.' },
      {
        label: 'Garancia:',
        text: 'a vásárlástól számított 30 napon belül visszakérheted a pénzed, a szabályaink szerint.',
      },
    ],
  },
  {
    id: 'penzvisszaterites',
    title: 'Pénzvisszatérítés',
    paragraphs: [
      { label: '30 napos garancia' },
      {
        text: '30 napos elégedettségi vagy pénzvisszafizetési garanciát adunk, ha a tartalom nem felel meg az elvárásaidnak. Azt, hogy 100%-ban digitális termékről van szó, egyértelműen jelezzük ezen az oldalon, a pénztárban és a visszaigazoló e-mailben.',
      },
      {
        label: 'Hogyan kérheted vissza a pénzed:',
        text: 'írj nekünk a vásárlástól számított 30 napon belül a vásárlási e-mailben megadott ügyfélszolgálati címre.',
      },
    ],
  },
]
